import React from 'react'
import { Box } from 'pcln-design-system'
import { AppDownload } from '@pcln/vip'

function AppDownloadWrapper() {
  return (
    <Box
      color="background.light"
      boxShadowSize="sm"
      borderRadius="xl"
      pr={[3, null, null, null, 4, 5]}
      pl={4}
    >
      <AppDownload gaTracking={() => {}} />
    </Box>
  )
}

export default AppDownloadWrapper
